exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ccm-client-settings--3tGHaMup8SsYfmTSLZxWgY button:focus {\n  outline: none;\n}\n\n.ccm-client-settings--nsw1EbSXmjXtjlQpE1QVu {\n  font-weight: bold;\n  font-size: 1.1em;\n  text-transform: capitalize;\n  text-decoration: underline;\n  text-decoration-color: #5b2f91;\n  color: white;\n  background-color: #5b2f91;\n  margin: 10px;\n}\n\n.ccm-client-settings--1H1fWnmbkoFlX1eR9b8vIJ {\n  margin-left: 10px;\n}\n\n.ccm-client-settings--2YtAy4Z7C8P6dm4ERujjnA {\n  font-size: 14px;\n  color: #42a6cb;\n  font-weight: bold;\n  flex-wrap: wrap;\n  word-wrap: break-word;\n}\n\n.ccm-client-settings--2YtAy4Z7C8P6dm4ERujjnA.ccm-client-settings--1Cn35h7Gw0wTCQfsFU1y6N {\n  color: gray;\n}\n\n.ccm-client-settings--2ezlikH7T0sXgFehGtBalt {\n  color: #5b2f91;\n}\n", ""]);

// exports
exports.locals = {
	"verticalTabContainer": "ccm-client-settings--3tGHaMup8SsYfmTSLZxWgY",
	"verticalTabContainer": "ccm-client-settings--3tGHaMup8SsYfmTSLZxWgY",
	"item_header_label": "ccm-client-settings--nsw1EbSXmjXtjlQpE1QVu",
	"itemHeaderLabel": "ccm-client-settings--nsw1EbSXmjXtjlQpE1QVu",
	"item_li": "ccm-client-settings--1H1fWnmbkoFlX1eR9b8vIJ",
	"itemLi": "ccm-client-settings--1H1fWnmbkoFlX1eR9b8vIJ",
	"configure_item_btn": "ccm-client-settings--2YtAy4Z7C8P6dm4ERujjnA",
	"configureItemBtn": "ccm-client-settings--2YtAy4Z7C8P6dm4ERujjnA",
	"inactive": "ccm-client-settings--1Cn35h7Gw0wTCQfsFU1y6N",
	"inactive": "ccm-client-settings--1Cn35h7Gw0wTCQfsFU1y6N",
	"item_selected": "ccm-client-settings--2ezlikH7T0sXgFehGtBalt",
	"itemSelected": "ccm-client-settings--2ezlikH7T0sXgFehGtBalt"
};